import EventForm from "./Event/EventForm";
import Layout from "./Components/Layout";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginRegister from "./Login/LoginRegister";
import ContactReg from "./Login/ContactReg";
import UpdatePassword from "./Login/UpdatePassword";
import EventDetails from "./Event/EventDetails";
import CaptionsPreview from "./Event/CaptionsPreview";
import OrgEvents from "./Event/OrgEvents";
import { useLoginResult } from "./State/LoginResultContext";
//import Checkout from "./Checkout/Checkout";
import Admin from "./Admin/Admin";
import UsersTable from "./Admin/UsersTable";
import UsageTable from "./Admin/UsageTable";
import PaginatedEvents from "./Event/PaginatedEvents";
import Overview from "./Event/Overview";
import QrCodeOverview from "./Event/QrCodeOverview";
import Profile from "./Event/Profile";
import ContactUS from "./Event/ContactUS";
import Signout from "./Login/Signout";
import ManagePlan from "./Plans/ManagePlan";
import TeamMembers from "./Team/TeamMembers";
import NotFound from "./Components/NotFound";
import { Toaster } from "react-hot-toast";
import "./App.css";
import Unauthorized from "./Event/Unauthorized";

function App() {
  const { loginResults } = useLoginResult();

  const unAuthenticated = () => {
    return loginResults === null;
  };

  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#1a0a2e",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.2)",
          },
          success: { iconTheme: { primary: "#22c55e" } },
          error: { iconTheme: { primary: "#ef4444" } },
        }}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/loginregister" />} />
        <Route
          path="/contact-reg/:organizationId/:email"
          element={<ContactReg />}
        />
        <Route path="/updatepassword/:tokenHash" element={<UpdatePassword />} />
        <Route path="/loginregister" element={<LoginRegister />} />
        <Route
          path="/events"
          element={
            unAuthenticated() ? <Navigate to="/loginregister" /> : <Layout loginResults={loginResults}><EventForm /></Layout>
          }
        />
        <Route
          path="/my-events"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <OrgEvents />
              </Layout>
            )
          }
        />
        <Route
          path="/my-event-history"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <PaginatedEvents />
              </Layout>
            )
          }
        />
        <Route
          path="/eventdetails"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <EventDetails />
            )
          }
        />
        <Route
          path="/captions-preview"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <CaptionsPreview />
            )
          }
        />
        {/* <Route
          path="/checkout"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults} >
                <Checkout />
              </Layout>
            )
          }
        /> */}
        <Route
          path="/manage-plan"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <ManagePlan />
              </Layout>
            )
          }
        />
        <Route
          path="/admin"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <Admin />
              </Layout>
            )
          }
        />
        <Route
          path="/customers"
          element={
            loginResults?.isSuperUser ? (
              <Layout loginResults={loginResults}>
                <UsersTable />
              </Layout>
            ) : (
              <Layout loginResults={loginResults}>
                <Unauthorized />
              </Layout>
            )
          }
        />
        <Route
          path="/user-usage/:id"
          element={
            loginResults?.isSuperUser ? (
              <Layout loginResults={loginResults}>
                <UsageTable />
              </Layout>
            ) : (
              <Layout loginResults={loginResults}>
                <Unauthorized />
              </Layout>
            )
          }
        />
        <Route
          path="/overview"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <Overview />
              </Layout>
            )
          }
        />
        {/* <Route
          path="/qr-code-overview"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults} >
                <QrCodeOverview />
              </Layout>
            )
          }
        /> */}
        <Route
          path="/profile"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <Profile />
              </Layout>
            )
          }
        />
        <Route
          path="/contact-us"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <ContactUS />
              </Layout>
            )
          }
        />
        <Route
          path="/team-members"
          element={
            loginResults?.isAdminUser && (loginResults?.isMultisitePlan || loginResults?.isSinglesitePlan) ? (
              <Layout loginResults={loginResults}>
                <TeamMembers />
              </Layout>
            ) : (
              <Layout loginResults={loginResults}>
                <Unauthorized />
              </Layout>
            )
          }
        />
        <Route
          path="/signout"
          element={
            unAuthenticated() ? (
              <Navigate to="/loginregister" />
            ) : (
              <Layout loginResults={loginResults}>
                <Signout />
              </Layout>
            )
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
export default App;
